import { Box, customStyled } from '@mafc/trolly';
import { RoundCornerButton } from 'common/styled/Button.style';

export const ErrorMessage = customStyled(Box)(({ theme: { fontSizes, space } }) => ({
  fontSize: fontSizes[3],
  marginTop: space[3],
  marginBottom: space[3],
}));

export const TryAgainButton = customStyled(RoundCornerButton)(({ theme: { space } }) => ({
  marginBottom: space[4],
}));
